import { render } from "./GoBack.vue?vue&type=template&id=42d4d926&scoped=true"
const script = {}

import "./GoBack.vue?vue&type=style&index=0&id=42d4d926&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d4d926"]])

export default __exports__